<template>
  <div>
    <v-btn color="primary" @click="dialog = true"
      ><v-icon class="mr-2">mdi-cash</v-icon> Wages</v-btn
    >
    <v-dialog v-model="dialog" persistent max-width="1300px">
      <v-card>
        <ModalHeader title="WAGES" icon="mdi-cash" @close="dialog = false" />
        <v-card-text class="pa-4">
          <div class="d-flex">
            <v-text-field
              outlined
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Employee Name"
              single-line
              hide-details
              clearable
              class="mb-3 mr-5"
            ></v-text-field>
            <v-select
              outlined
              dense
              v-model="selectedBranchId"
              :items="branchOptions"
              item-text="branch_name"
              item-value="id"
              label="Branch"
              clearable
              hide-details
              style="max-width: 300px"
              @change="onBranchChange"
            ></v-select>
          </div>
          <v-data-table
            dense
            :items="filteredWages"
            :headers="wage_headers"
            :search="search"
            :custom-filter="filterByEmployeeName"
          >
            <template v-slot:item.action="{ item }">
              <div class="d-flex">
                <v-btn color="success" @click="print(item)" icon
                  ><v-icon>mdi-printer</v-icon></v-btn
                >
                <v-btn color="red" @click="del(item)" icon
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </template>
            <template v-slot:item.deductions="{ item }">
              <ul
                v-if="Array.isArray(item.deductions) && item.deductions.length"
                class="my-1 pl-4"
              >
                <li v-for="(dec, i) in item.deductions" :key="i">
                  {{ dec.name }}: {{ formatCurrency(dec.amount) }}
                </li>
              </ul>
              <span v-else>-</span>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ formatDate(item.created_at) }}
            </template>
            <template v-slot:item.pay_type="{ item }">
              <v-chip
                small
                :color="item.pay_type === 'fixed' ? 'green' : 'blue-grey'"
                text-color="white"
              >
                {{ item.pay_type === "fixed" ? "Fixed" : "Daily" }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false" color="secondary"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption">wagesModal.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// import moment from "moment";
export default {
  data() {
    return {
      dialog: false,
      search: "",
      selectedBranchId: null,
      wage_headers: [
        { text: "Action", value: "action" },
        { text: "ID", value: "id" },
        { text: "Employee Name", value: "employee.name" },
        { text: "Pay Type", value: "pay_type" },
        { text: "Month", value: "month" },
        { text: "Year", value: "year" },
        { text: "Total Days Worked", value: "total_days_worked" },
        { text: "Deductions", value: "deductions" },
        { text: "Notes", value: "notes" },
        { text: "Total Gross", value: "total_gross" },
        { text: "Total Net", value: "total_net" },
        { text: "Transacted By", value: "inserted_by" },
        { text: "Created at", value: "created_at" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      wages: "wage/wages",
      user: "auth/user",
      default_server_url: "auth/default_server_url",
      branches: "branch/branches",
    }),
    branchOptions() {
      return this.branches || [];
    },
    filteredWages() {
      if (!this.selectedBranchId) return this.wages;
      return this.wages.filter(
        (w) => w.employee && w.employee.branch_id === this.selectedBranchId
      );
    },
  },
  methods: {
    ...mapActions({
      delete_wage: "wage/delete_wage",
      get_wages: "wage/get_wages",
    }),
    onBranchChange() {
      this.get_wages(this.selectedBranchId);
    },
    // restrict the data-table search to the employee name only
    filterByEmployeeName(value, search, item) {
      if (!search) return true;
      const name =
        item.employee && item.employee.name ? item.employee.name : "";
      return name.toLowerCase().includes(search.toLowerCase());
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value || 0);
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    print(item) {
      // Implement print functionality
      window.open(
        this.default_server_url +
          "/print_payslip/" +
          item.id +
          "/" +
          ((item.employee && item.employee.branch_id) || this.user.branch.id),
        "_blank"
      );
    },
    async del(item) {
      if (
        await this.$confirm({
          title: "Delete Wage",
          message: "Are you sure you want to delete this wage?",
          color: "red",
          icon: "mdi-delete",
        })
      ) {
        await this.delete_wage(item.id);
        this.$alert({
          title: "Success",
          message: "Wage deleted successfully!",
          color: "success",
          icon: "mdi-check-circle",
        });
      }
    },
  },
  mounted() {
    this.get_wages();
    if (!this.branches || this.branches.length === 0) {
      this.$store.dispatch("branch/get_branches");
    }
    this.selectedBranchId = this.user.branch_id;
  },
};
</script>
